export class RmScreenListingEntity {
  id!: string;
  rMName!: string;
  teamName!: string;
  pcCode!: string;
  officeNumber!: string;
}
